import {createApp} from 'vue'
import StafetDonationStepPrivat from './StafetDonationStepPrivat'

const el = '.kb-component--stafet-donation-step-privat'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetDonationStepPrivatDOM)=>{
            const component = createApp(StafetDonationStepPrivat).use(Store)
            component.mount(StafetDonationStepPrivatDOM)
        })
    }
}